<template>
  <div class="section">
    <div class="title-box" v-if="title">
      <div class="title-bg"><span></span></div>
      <div class="title">
        <div class="title-text MF_1">
        <img class="star-a" src="@/assets/images/star-a.svg" alt="star" srcset=""> 
        {{ title }}
        <img class="star-b" src="@/assets/images/star-a.svg" alt="star" srcset="">
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bot-bg"></div>
      <div id="card-list" :class="{ 'less-card': !expanded && cardVersionList.length > 4 }">
        <div class="card-list-grid">
          <div
            class="card-item"
            v-for="item in showList"
            @click="goToDetail(item)"
          >
            <div v-if="item.image" class="card-images">
              <img :src="item.image" :alt="item.name" class="card-img" />
              <!-- <img src="https://jihuanshe-imagex.jihuanshe.com/pkm/card_versions/CS4bC-085_sc.png" :alt="item.name" class="card-img" /> -->
            </div>
            <div class="card-content">
              <div class="card-name ells2 CH_6_Bold">{{ item.name }}</div>
              <div>
                <div class="card-info">
                  <span v-if="item.number" class="card-number CH_7_Regular">{{ item.number }}</span>
                  <span v-if="item.rarity" class="card-rarity EN_7_Bold">{{ item.rarity }}</span>
                </div>
              <div v-if="item.remark" class="card-remark ells3 CH_7_Regular">{{ item.remark }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!expanded && cardVersionList.length > 4" class="more-btn-box">
          <div class="more-btn" @click="openExpanded"><span class="EN_6_Regular">{{ $t('common.more') }}</span><span class="JHSicon JHS-arrow_down"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { checkLoginAndGo } from '@/utils/token';
import { track } from '@/utils/tracking';

declare const jhsapp: any;
interface cardListItem {
  name?: string;
  number?: string;
  rarity?: string;
  image?: string;
  remark?: string;
  link?: string;
  miniprogram_link?: string;
  game_key?: string;
  game_sub_key?: string;
  card_id?: string;
  card_name?: string;
  object_type?: string;
  card_version_id?: string;
  card_number?: string;
}

const props = defineProps<{
  cardVersionList: cardListItem[];
  title: string;
  module_ID: string;
  module_type: string;
}>();

const expanded = ref(false);

const showList = computed(() => {
  return expanded.value ? props.cardVersionList : props.cardVersionList.slice(0, 6);
});

const openExpanded = () => {
  checkLoginAndGo(()=>{
    expanded.value = true;
  })
}

// 跳转详情页
const goToDetail = (item: cardListItem) => {
  track('H5Landing_module_operation', {
    operation: 'click_on_link_card',
  });
  track('lst_H5Landing_module_card', {
    module_ID: props.module_ID,
    module_type: props.module_type,
    game_key: item.game_key,
    game_sub_key: item.game_sub_key,
    products: {
      card_id: item.card_id,
      card_name: item.card_name,
      object_type: item.object_type,
      card_version_id: item.card_version_id,
      card_number: item.card_number,
      rarity: item.rarity,
    }
  })
  checkLoginAndGo(()=>{
    try {
      if (item.link) {
        jhsapp.router(item.link);
      } else if (item.miniprogram_link) {
        jhsapp.router(item.miniprogram_link);
      }
    } catch (error) {
      console.error('跳转失败:', error);
    }
  })
};
</script>

<style lang="scss" scoped>
@import '@/styles/section.scss';
#card-list {
  width: 100%;
}

.less-card {
  height: 303px;
  overflow: hidden;
}

.card-list-grid {
  width: 100%; 
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--gap-8) var(--gap-6);
}

.card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--gap-5);

  .card-images {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    padding: 0 13.5%;
    border-radius: 10.115px;
    background: var(--container-surface-gray-alpha);
  }

  .card-img {
    width: 100%;
  }


  .card-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--gap-2 );
    align-self: stretch;

    .card-name {
      color: var(--on-container-text-primary);
    }

    .card-info{
      display: flex;
      align-items: flex-start;
      align-content: flex-start;
      gap: var(--gap-3);
      align-self: stretch;
      flex-wrap: wrap;
    }

    .card-number{
      color: var(--on-container-text-thirdry);
    }
    
    .card-rarity{
      color: var(--on-container-text-thirdry);
    }

    .card-remark {
      color: var(--on-container-text-thirdry);
    }
  }
}
</style> 